<template>

    <div>
    	<Utenti :livello="5" :idPersonaGiuridica="idPersonaGiuridica"></Utenti>
    </div>

</template>



<script>

import Utenti from '@/components/common/Utenti.vue'


export default {
    name:"UtentiClienti",
    components:{
        Utenti,
    },
    data() {
        return {
            idPersonaGiuridica: null
        }
    },
    mounted() {
        this.idPersonaGiuridica = this.$route.query.idPersonaGiuridica ? parseInt(this.$route.query.idPersonaGiuridica) : null
    }

}
</script>